import React from 'react';
import LinkIcon from '@atlaskit/icon/core/link';
import UrlField from '@atlassian/jira-issue-create-commons/src/ui/url-field/index.tsx';
import { URL_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { TextFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig } from '../types.tsx';
import { urlFieldWriter } from '../writers/index.tsx';

export const UrlCustomFieldTypeConfig: FieldTypeConfig<string> = {
	icon: LinkIcon,
	type: URL_CF_TYPE,
	Component: UrlField,
	placeholder: <TextFieldPlaceholder />,
	writer: urlFieldWriter,
};
